module.exports = __webpack_public_path__ + "img/oil_paint_large_1.143ca61f.png";